import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../customize-spot-theme/customizeSpotTheme.css";
import "./customizeColours.css";
import { fetchThemeData } from "../../themeSlice";
import { selectAdminToken } from "../../sessionSlice";
import ColorsEditor from "./ColorsEditor";
import QuestionsEditor from "./QuestionsEditor";

const CustomizeColours = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const { currentTheme, data } = useSelector((s) => s.theme);

  const colors = Array.isArray(data?.colors) ? data.colors : [];
  const questions = Array.isArray(data?.questions) ? data.questions : [];

  useEffect(() => {
    if (currentTheme) dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch, currentTheme]);

  return (
    <>
      <div className="back-button-holder">
        <button type="button" className="back-button" onClick={() => navigate("/admin/rules")}>
          <i className="fa-solid fa-arrow-left" /> Back
        </button>
      </div>
      <div className="catmgr-page">
        <ColorsEditor
          data={data}
          currentTheme={currentTheme}
          adminToken={adminToken}
          questions={questions}
        />
        <QuestionsEditor
          data={data}
          currentTheme={currentTheme}
          adminToken={adminToken}
          colors={colors}
        />
      </div>
    </>
  );
};

export default CustomizeColours;
